import React from "react";
import SuiBox from "components/SuiBox";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import ErrorAlert from "components/ErrorAlert";
import CustomSelect from "components/CustomSelect";
import {
  Card,
  CircularProgress,
  Grid,
  Icon,
} from "@mui/material";
import SuiTypography from "components/SuiTypography";
import SuiButton from "components/SuiButton";
import { getUsersReq, getUserLeaveAndWFHReportReq, getLeaveAndWFHDetails } from "services/api";
import { isEmpty } from "lodash";
import { customSelectStyles } from "../../leaveAndWFHReport.constants";
import { useLocation } from "react-router-dom";
import { DASHBOARD_CARDS } from "../../leaveAndWFHReport.constants";
import MiniStatisticsCard from "examples/Cards/StatisticsCards/MiniStatisticsCard";
import { DateRangePicker } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { TextField, Popover } from "@mui/material";
import moment from "moment";
import {
  REPORT_BUTTON_SX,
  REPORT_TOOLBAR_SX,
  reportFieldSx,
} from "layouts/reports/reports.constants";

function LeaveAndWFHReportContent() {
  const [errorMessage, setErrorMessage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isReportLoading, setIsReportLoading] = useState(false);
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState({});
  const [dashboardCards, setDashboardCards] = useState();
  const [selectedDate, setSelectedDate] = useState([]);
  const [dateRange, setDateRange] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [filterBy, setFilterBy] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [dashboardTable, setDashboardTable] = useState([]);
  const pageLimit = 10;
  const [filters, setFilters] = useState(null);
  const [filterName, setFilterName] = useState(null);

  const { state } = useLocation();

  // Store
  const {
    auth: { admin, team, channel },
  } = useSelector((state) => state);

  const getUsers = async () => {
    setIsLoading(true);
    try {
      const admin_id = admin.id;
      const { data } = await getUsersReq({
        admin_id,
        team_id: team.id,
        channel_id: channel.id,
      });
      setUsers(data);
      if (state?.value) {
        setSelectedUser(state);
        generateReport(state);
      }
    } catch (err) {
      setErrorMessage(err.response?.data.message);
    }
    setIsLoading(false);
  };

  const generateReport = async (user) => {
    if ((!isEmpty(selectedUser) || !isEmpty(user)) && selectedDate.length === 2) {
      setIsReportLoading(true);
      try {
        const admin_id = admin.id;
        const from = selectedDate[0].toLocaleDateString("en-GB");
        const to = selectedDate[1].toLocaleDateString("en-GB");
        const { data } = await getUserLeaveAndWFHReportReq({
          admin_id,
          team_id: team.id,
          channel_id: channel.id,
          user_slack_id: selectedUser.value || user.value,
          from,
          to,
        });
        setDashboardCards(data);
      } catch (err) {
        setErrorMessage(err.response?.data.message);
      }
      setIsReportLoading(false);
    }
  };

  const handleFilterClick = async (filter, name) => {
    setFilters(filter);
    setFilterName(name);
    try {
      setIsLoading(true);
      const admin_id = admin.id;
      const from = selectedDate[0].toLocaleDateString("en-GB");
      const to = selectedDate[1].toLocaleDateString("en-GB");

      const { data } = await getLeaveAndWFHDetails({
        admin_id,
        team_id: team.id,
        channel_id: channel.id,
        user_slack_id: selectedUser.value,
        from,
        to,
        filter,
      });

      setDashboardTable(data.filteredDates);
    } catch (err) {
      setErrorMessage(err.response?.data.message);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getUsers();
  }, []);

  return (
    <>
      {errorMessage && (
        <ErrorAlert
          color="error"
          message={errorMessage}
          clearError={() => setErrorMessage(null)}
        />
      )}
      <SuiBox py={3}>
        <SuiBox display="flex" alignItems="center" flexWrap="wrap" sx={REPORT_TOOLBAR_SX}>
          <SuiBox className="w-340" sx={{ height: "35px" }}>
            {isLoading ? (
              <CircularProgress color="dark" size={18} />
            ) : (
              <CustomSelect
                key={users.length}
                isSearchable={true}
                customStyles={customSelectStyles}
                options={users}
                value={selectedUser}
                placeholder="Select Employee"
                onChange={(data) => setSelectedUser(data)}
              />
            )}
          </SuiBox>
          <SuiBox sx={{ height: "35px", display: "flex", alignItems: "center" }}>
            <TextField
              value={
                selectedDate.length === 2
                  ? `${moment(selectedDate[0]).format("DD/MM/YYYY")} - ${moment(
                      selectedDate[1]
                    ).format("DD/MM/YYYY")}`
                  : ""
              }
              placeholder="Select Date Range"
              onClick={(e) => setAnchorEl(e.currentTarget)}
              InputProps={{ readOnly: true }}
              size="small"
              sx={{ ...reportFieldSx, width: 220 }}
            />
            <Popover
              open={Boolean(anchorEl)}
              anchorEl={anchorEl}
              onClose={() => setAnchorEl(null)}
              anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
              sx={{
                "& .rdrDefinedRangesWrapper": {
                  display: "none",
                },
              }}
            >
              <DateRangePicker
                ranges={dateRange}
                onChange={(ranges) => {
                  setDateRange([ranges.selection]);
                  setSelectedDate([ranges.selection.startDate, ranges.selection.endDate]);
                }}
                showSelectionPreview={true}
                moveRangeOnFirstSelection={false}
                months={1}
                direction="horizontal"
                staticRanges={[]}
                inputRanges={[]}
              />
            </Popover>
          </SuiBox>
          <SuiButton
            variant="gradient"
            color="secondary"
            size="small"
            onClick={generateReport}
            sx={REPORT_BUTTON_SX}
          >
            Generate Report
            <Icon sx={{ fontWeight: "bold" }}>arrow_forward</Icon>
          </SuiButton>
        </SuiBox>
      </SuiBox>
      <SuiBox pb={3}>
        <Grid container spacing={3}>
          {isReportLoading ? (
            <Grid item xs={12} md={12} lg={12}>
              <Card className="h-100">
                <SuiBox
                  display="flex"
                  flexDirection="column"
                  justifyContent="center"
                  alignItems="center"
                  p={3}
                >
                  <CircularProgress color="dark" size={30} />
                </SuiBox>
              </Card>
            </Grid>
          ) : dashboardCards ? (
            DASHBOARD_CARDS.map((dashboardCard, index) => {
              return (
                <Grid
                  onClick={() => handleFilterClick(dashboardCard.filterBy, dashboardCard.text)}
                  key={index}
                  item
                  xs={12}
                  sm={6}
                  xl={4}
                  className="cursor-pointer"
                >
                  <MiniStatisticsCard
                    title={{ text: `${dashboardCard.text}` }}
                    count={
                      isReportLoading ? (
                        <CircularProgress color="dark" size={18} />
                      ) : (
                        dashboardCards[dashboardCard.name]
                      )
                    }
                    icon={{
                      color: `${dashboardCard.iconColor}`,
                      component: `${dashboardCard.iconComponent}`,
                    }}
                  />
                </Grid>
              );
            })
          ) : (
            <Grid item xs={12} md={12} lg={12}>
              <Card className="h-100">
                <SuiBox
                  display="flex"
                  flexDirection="column"
                  justifyContent="center"
                  alignItems="center"
                  p={3}
                >
                  <Icon fontSize="large" color="error" className="cursor-pointer">
                    {"report"}
                  </Icon>
                  <SuiTypography
                    component="span"
                    variant="button"
                    fontWeight="regular"
                    textTransform="capitalize"
                    color={"dark"}
                    opacity={0.5}
                    m={3}
                    sx={{ lineHeight: 0 }}
                  >
                    No records found
                  </SuiTypography>
                </SuiBox>
              </Card>
            </Grid>
          )}
        </Grid>
      </SuiBox>
      {filters && (
        <SuiBox mt={4} mb={4}>
          <SuiTypography variant="h4" fontWeight="medium" mb={2}>
            {filterName} ({moment(selectedDate[0], "MM/DD/YYYY").format("MMMM D, YYYY")} to{" "}
            {moment(selectedDate[1], "MM/DD/YYYY").format("MMMM D, YYYY")})
          </SuiTypography>

          <Card>
            <SuiBox p={3}>
              {dashboardTable.length > 0 ? (
                <SuiBox>
                  <SuiBox
                    display="flex"
                    backgroundColor="#f8f9fa"
                    borderRadius="0.5rem 0.5rem 0 0"
                    p={2}
                    sx={{
                      borderBottom: "2px solid #dee2e6",
                    }}
                  >
                    <SuiBox flex="1" px={1}>
                      <SuiTypography variant="button" fontWeight="bold" color="dark">
                        Date
                      </SuiTypography>
                    </SuiBox>
                    <SuiBox flex="1" px={1}>
                      <SuiTypography variant="button" fontWeight="bold" color="dark">
                        Day
                      </SuiTypography>
                    </SuiBox>
                    <SuiBox flex="1" px={1}>
                      <SuiTypography variant="button" fontWeight="bold" color="dark">
                        Status
                      </SuiTypography>
                    </SuiBox>
                  </SuiBox>

                  <SuiBox>
                    {dashboardTable.map((dateItem, index) => (
                      <SuiBox
                        key={index}
                        display="flex"
                        p={2}
                        sx={{
                          borderBottom:
                            index < dashboardTable.length - 1 ? "1px solid #dee2e6" : "none",
                          "&:hover": {
                            backgroundColor: "#f8f9fa",
                          },
                        }}
                      >
                        <SuiBox flex="1" px={1}>
                          <SuiTypography variant="button" fontWeight="medium">
                            {moment(dateItem, "DD/MM/YYYY").format("DD MMM YYYY")}
                          </SuiTypography>
                        </SuiBox>
                        <SuiBox flex="1" px={1}>
                          <SuiTypography variant="caption" color="text">
                            {moment(dateItem, "DD/MM/YYYY").format("dddd")}
                          </SuiTypography>
                        </SuiBox>
                        <SuiBox flex="1" px={1}>
                          <SuiTypography variant="caption" color="success">
                            {filterName}
                          </SuiTypography>
                        </SuiBox>
                      </SuiBox>
                    ))}
                  </SuiBox>
                </SuiBox>
              ) : (
                <SuiBox textAlign="center" py={4}>
                  <Icon fontSize="large" color="error">
                    report
                  </Icon>
                  <SuiTypography variant="button" color="text" display="block" mt={1}>
                    No data found for the selected criteria.
                  </SuiTypography>
                </SuiBox>
              )}
            </SuiBox>
          </Card>
        </SuiBox>
      )}
    </>
  );
}

export default LeaveAndWFHReportContent;
